import React from 'react';
import { Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function UpcomingLeavesWidget() {
  const navigate = useNavigate();
  const upcomingLeaves = [{
    id: 1,
    type: 'Congés payés',
    startDate: '22 déc. 2023',
    endDate: '31 déc. 2023',
    days: 6
  }];
  return <div className="bg-white rounded-lg shadow-sm p-5 min-h-[400px] flex flex-col" data-id="element-2174">
      <div className="flex items-center justify-between mb-4" data-id="element-2175">
        <h3 className="font-semibold text-gray-900" data-id="element-2176">Congés à venir</h3>
        <Calendar className="h-5 w-5 text-blue-600" data-id="element-2177" />
      </div>
      {upcomingLeaves.length > 0 ? <div className="space-y-3 flex-1" data-id="element-2178">
          {upcomingLeaves.map(leave => <div key={leave.id} className="border-l-4 border-blue-500 pl-3 py-2" data-id="element-2179">
              <p className="font-medium text-gray-900" data-id="element-2180">{leave.type}</p>
              <p className="text-sm text-gray-600" data-id="element-2181">
                {leave.startDate} - {leave.endDate}
              </p>
              <p className="text-xs text-gray-500" data-id="element-2182">{leave.days} jours</p>
            </div>)}
        </div> : <div className="text-center py-4 flex-1 flex items-center justify-center" data-id="element-2183">
          <p className="text-gray-500" data-id="element-2184">Aucun congé prévu</p>
        </div>}
      <button onClick={() => navigate('/conges')} className="mt-4 w-full py-2 px-4 border border-gray-300 hover:bg-gray-50 rounded-md text-sm font-medium text-gray-700 transition-colors duration-150 ease-in-out" data-id="element-2185">
        Voir tous les congés
      </button>
    </div>;
}